import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './ATS_ButtonGroup.scss';
import { ComponentSync, LL_H_C, LL_V_L, TS_AppTools, TS_ButtonGroup, TS_PropRenderer } from '@nu-art/thunderstorm-frontend/index';
import { sleep } from '@nu-art/ts-common';
const buttons = [
    { label: 'Test 1', key: 'test-1' },
    { label: 'Test 2', key: 'test-2' },
    { label: 'Test 3', key: 'test-3' },
    { label: 'Test 4', key: 'test-4' },
];
export class ATS_ButtonGroup extends ComponentSync {
    static Screen = {
        name: 'ButtonGroup',
        key: 'button-group',
        group: 'Components',
        renderer: this,
    };
    renderGroup = (direction, async) => {
        return _jsx(TS_ButtonGroup, { controlled: true, buttons: buttons, selectedKey: this.state.selectedKey, clickCallback: async (key) => {
                this.logInfo(key);
                if (async)
                    await sleep(1000);
                this.setState({ selectedKey: key });
            }, direction: direction });
    };
    render() {
        return _jsxs(_Fragment, { children: [TS_AppTools.renderPageHeader('Button Test'), _jsxs(LL_V_L, { className: 'ats-button-group', children: [_jsxs(LL_H_C, { children: [_jsx(TS_PropRenderer.Vertical, { label: 'horizontal group', children: this.renderGroup('horizontal') }), _jsx(TS_PropRenderer.Vertical, { label: 'horizontal group - async', children: this.renderGroup('horizontal', true) })] }), _jsxs(LL_H_C, { className: 'ats-button-group', children: [_jsx(TS_PropRenderer.Vertical, { label: 'vertical group', children: this.renderGroup('vertical') }), _jsx(TS_PropRenderer.Vertical, { label: 'vertical group - async', children: this.renderGroup('vertical', true) })] })] })] });
    }
}
//# sourceMappingURL=ATS_ButtonGroup.js.map